import { CONTENT_DETAILS } from 'components/ContentReporting/ContentLegalReporting/content-legal-reporting-config';

import { CLAIM_TYPE } from '../types';

export const getContentDescriptionLabel = (claimType?: CLAIM_TYPE) => {
  return claimType === CLAIM_TYPE.OTHER
    ? CONTENT_DETAILS.labels.REPORTED_CONTENT_DESCRIPTION_NON_IP
    : CONTENT_DETAILS.labels.REPORTED_CONTENT_DESCRIPTION;
};
